
import { Vue, Options } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({})
export default class DefaultIFrame extends Vue {
  @Prop({ required: true }) name!: string
  @Prop({ required: true }) url!: string
  @Prop({ required: true }) token!: string
  @Prop({ required: false }) queryParameter?: string

  get iFrameName(): string {
    return `iframe-${this.name.replace(/ /g, '-').toLowerCase()}`
  }

  get iframeUrl(): string {
    const separator = this.url.includes('?') ? '&' : '?'
    let destinationUrl = `${this.url}${separator}token=${this.token}`
    if (this.queryParameter) {
      destinationUrl += `&${this.queryParameter}`
    }
    return destinationUrl
  }

  closeModal() {
    this.$emit('close')
  }
}
